module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-75.65ef1c34.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-75.png
// module id = 3356
// module chunks = 11